// StatePosts.js  

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import LooksPost from './LooksPost';
import { Typography } from '@mui/material';
import './UsersPosts.css';

const StatePosts = () => {
  const { state } = useParams();
  const { posts } = useContext(LooksPostsContext);
  const [statePosts, setStatePosts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (state && posts.length) {
      const filtered = posts.filter(
        (p) =>
          p.state === state &&
          !p.deleted &&
          !p.isReported &&
          (p.showOnHomePage || p.showInDiscoverBox)
      );
      setStatePosts(filtered);
    }
  }, [state, posts]);

  return (
    <div className="users-posts-container">
      <h1>
        <span className="location-link">{state}</span>
      </h1>

      {statePosts.length ? (
        statePosts.map((post) => <LooksPost key={post.id} {...post} />)
      ) : (
        <Typography variant="body1" color="text.secondary">
          No posts found in this state.
        </Typography>
      )}
    </div>
  );
};

export default StatePosts;
